import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, forwardRef, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

import { BaseControlValueAccessor } from 'rev-shared/util/BaseControlValueAccessor';

let nextId = 1;

@Component({
	selector: 'vb-toggle-button',
	templateUrl: './VbToggleButton.Component.html',
	imports: [
		CommonModule,
		FormsModule
	],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => VbToggleButtonComponent),
		multi: true
	}],
	styleUrl: './vb-toggle-button.ng.less'
})
export class VbToggleButtonComponent extends BaseControlValueAccessor<boolean> implements OnInit, OnChanges {
	@Input() public toggleId: string = `vb-toggle-btn-${nextId++}`;
	@Input() public disabled: boolean;
	@Input() public ariaLabel: string;
	@Input() public labelName: string;
	@Input() public labelCssClass: boolean;

	public ngOnInit(): void {
		this.setDisabledState(this.disabled);
		const labels = +!!this.toggleId + +!!this.ariaLabel + +!!this.labelName;
		if(labels === 0) {
			console.log('VbToggleButtonComponent, no accessible label found.');
		}
		else if(labels > 1) {
			console.log('VbToggleButtonComponent, multiple accessible label found. Remove extra labels.');
		}
	}

	public ngOnChanges(changes): void {
		if (changes.disabled) {
			this.setDisabledState(this.disabled);
		}
	}

	public onChange(): void {
		this.updateModelValue(this.value);
	}

	public toggle(): void {
		if(!this.disabled) {
			this.value = !this.value;
			this.updateModelValue(this.value);
		}
	}
}
